<template>
	<header class="nav-wrapper w-full" :class="changeNav">
		<div class="gradient-bar"></div>
		<div class="container mx-auto px-8 md:px-24 py-6">
			<nav class="flex justify-between items-start">
				<h1>
					<img src="./../assets/images/rwe-logo-revised.svg" alt="RWE Logo" width="175" height="auto">
				</h1>
				<div v-if="hideNavLinks" class="navigation-links">
					<ul class="flex">
						<li class="px-2">
							<router-link to="/">
								<font-awesome-icon :icon="['fas', 'home']" transform="shrink-8" class="fa-3x icon icon--border"/>
							</router-link>
						</li>
						<li class="px-2">
							<a href="#" @click="scrollToTop">
								<font-awesome-icon :icon="['fas', 'chevron-up']" transform="shrink-8" class="fa-3x icon icon--border"/>
							</a>
						</li>
					</ul>
				</div>
			</nav>
		</div>
	</header>
</template>

<script>
export default {
	name: 'main-header',
	props: {},
	data: function() {
		return {
			hideNavLinks: false,
			toggleSticky: false
		}
	},
	methods: {
		scrollToTop: function() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		}
	},
	watch: {
		'$route'() {
			if (this.$route.path !== '/') {
				this.hideNavLinks = true
				this.toggleSticky = true
			}
			else {
				this.hideNavLinks = false
				this.toggleSticky = false
			}
		}
	},
	computed: {
		changeNav() {
			return {
				'sticky': this.toggleSticky,
				'top-0': this.toggleSticky
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="postcss">
	.nav-wrapper {
		height: auto;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		background-color: #fff;
		z-index: 10;
	}
	.gradient-bar {
		width: 100%;
		height: 10px;
		background-image: linear-gradient(to top right, theme('colors.olive-green-alt'), theme('colors.cyan'));
	}
	.navigation-links {
		li {
			margin-top: 2px;
			a {
				display: inline-block;
			}
		}
	}
	.icon {
		width: 46px;
		height: 46px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.icon--border {
		border: 2px solid theme('colors.black-blue');
		border-radius: 50%
	}
	@media screen and (min-width: 361px) {
		.icon {
			width: 48px;
			height: 48px;
		}
	}
</style>
